import {
    ///******* */
    SIGN_IN,
    SIGN_OUT,
    USER_NAME,
    USER_DETAIL,
    CODE_ASANA,
    SIGN_OUT_OBJ,
    MESSAGE_POPUP,
    NEW_USER,
    NEW_USER_DETAIL,
    CHAT_ON,
    CHAT_OFF,
    STEP_ONBOARDING,
    LIST_LESSONS,
    STATE_CHAT,
    SELECT_OBJETIVE,
    LIST_OBJETIVES,
    END_CHAT,
    MESSAGE_CHAT,
    ON_MESSAGE,
    NUM_TASK_END,
    QUERY_DB,
    UTILS_USER,
    CONTROL_FLOW_CX,

} from './types';




///****** */

export const signIn = (userId) => {
  
    return {
        type: SIGN_IN,
        payload: userId
    };
};

export const signOut = () => {
    return {
        type: SIGN_OUT
    };
};

export const userName = (user) => {

    return {
        type: USER_NAME,
        payload: user
    };
};

export const userDetails = (useroDetail) => {

    return {
        type: USER_DETAIL,
        payload: useroDetail
    };
};

export const messageAsanas = (code) => {

    return {
        type: CODE_ASANA,
        payload: code
    };
};

export const Singauth = (obj) => {
    return {
        type: SIGN_OUT_OBJ,
        payload: obj
    };
};

export const popupBot = (message) => {

    return {
        type: MESSAGE_POPUP,
        payload: message
    };
};

export const newUsers = (newUser) => {

    return {
      type: NEW_USER,
      payload: newUser
    };
  };

  export const newUserDetails = (user) => {
    return {
      type: NEW_USER_DETAIL,
      payload: user
    };
  };

  
  /////// dashboard

  
  export const chatOn = () => {
    return {
        type: CHAT_ON
    };
};
export const chatOff = () => {
    return {
        type: CHAT_OFF
    };
};
export const stepsOnboarding = (step) => {

    return {
      type: STEP_ONBOARDING,
      payload: step
    };
  };
  export const listlessons = (lesson) => {

    return {
      type: LIST_LESSONS,
      payload: lesson
    };
  };

  export const stateChats = (state) => {
    return {
      type: STATE_CHAT,
      payload: state
    };
  };

  /// tasks
  
  export const selectObjetives = (objective) => {
    return {
      type: SELECT_OBJETIVE,
      payload: objective
    };
  };

  //OKR

  export const listObjetives = (Objetive) => {

    return {
      type: LIST_OBJETIVES,
      payload: Objetive
    };
  };
  
  //chatZ

  export const endChatMessages = (text) =>(
    {
        type: END_CHAT,
        payload: text
    }
)

export const messageChat = (message) => {

  return {
      type: MESSAGE_CHAT,
      payload: message
  };
};

export const sendMessage = (message) =>(
  {
      type: ON_MESSAGE,
      payload: message
  }
)

export const numTasksEnd = (num) => {

  return {
    type: NUM_TASK_END,
    payload: num
  };
};

// efect 1

export const query_db = (q) => {

  return {
    type: QUERY_DB,
    payload: q
  };
};

// utils user

export const userUtils = (util) => {

  return {
    type: UTILS_USER,
    payload: util
  };
};

// control chat 
export const controlFlowCX = (control) => {

  return {
    type: CONTROL_FLOW_CX,
    payload: control
  };
};